import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      {/* Emergency Banner */}
      <div className="bg-red-600 text-white py-6">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-lg font-bold">
            If you are experiencing a mental health emergency, call 988 or go to your nearest emergency room
          </p>
        </div>
      </div>

      {/* Main Footer */}
      <footer className="bg-beige-light">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Column 1: Logo & Description */}
            <div>
              <img
                src="https://static.readdy.ai/image/97be066482875b82b2fddabc195c0943/9c4245f84ac76278cd8c587241d9204a.png"
                alt="Solutions Healthcare LLC"
                className="h-12 w-auto mb-4"
              />
              <p className="text-sm text-neutral-gray leading-relaxed mb-6">
                Compassionate mental health care for adults and seniors in Aurora, Colorado
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://www.instagram.com/solutionshealthcarellc/?utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center text-neutral-gray hover:text-primary transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center text-neutral-gray hover:text-primary transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center text-neutral-gray hover:text-primary transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div>
              <h3 className="text-xs uppercase tracking-wider text-neutral-blue font-semibold mb-6">Quick Links</h3>
              <ul className="space-y-4">
                <li>
                  <Link to="/about" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Our Services
                  </Link>
                </li>
                <li>
                  <Link to="/weight-loss" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Weight Loss Program
                  </Link>
                </li>
                <li>
                  <Link to="/rates" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Insurance & Rates
                  </Link>
                </li>
                <li>
                  <Link to="/patient-portal" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Patient Portal
                  </Link>
                </li>
                <li>
                  <Link to="/appointment" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Make an Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Resources */}
            <div>
              <h3 className="text-xs uppercase tracking-wider text-neutral-blue font-semibold mb-6">Resources</h3>
              <ul className="space-y-4">
                <li>
                  <Link to="/qmap" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    QMAP Training
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Mental Health Blog
                  </Link>
                </li>
                <li>
                  <Link to="/patient-portal" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Patient Forms
                  </Link>
                </li>
                <li>
                  <Link to="/employment" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Employment Opportunities
                  </Link>
                </li>
                <li>
                  <a href="#crisis" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                    Crisis Resources
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 4: Contact */}
            <div>
              <h3 className="text-xs uppercase tracking-wider text-neutral-blue font-semibold mb-6">Contact Us</h3>
              <ul className="space-y-4 text-sm">
                <li className="flex items-start space-x-3">
                  <i className="ri-map-pin-line text-primary mt-1"></i>
                  <span className="text-neutral-gray">2821-2851 South Parker RD, Suite 1-1030, Aurora, CO 80014</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-phone-line text-primary"></i>
                  <div className="flex flex-col">
                    <a href="tel:+17206552560" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                      (720) 655-2560
                    </a>
                    <a href="tel:+13037256096" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer">
                      (303) 725-6096
                    </a>
                  </div>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-printer-line text-primary"></i>
                  <span className="text-neutral-gray">Fax: (720) 964-0401</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-mail-line text-primary"></i>
                  <a href="mailto:Inquiry@solutionshealthcarellc.com" className="text-neutral-gray hover:text-primary transition-colors cursor-pointer break-all">
                    Inquiry@solutionshealthcarellc.com
                  </a>
                </li>
              </ul>
              <div className="mt-6 text-sm text-neutral-gray">
                <p className="font-semibold text-neutral-blue mb-2">Office Hours:</p>
                <p>Monday-Friday: 10:00 AM - 6:00 PM</p>
                <p>Saturday: By Appointment</p>
                <p>Sunday: By Appointment</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="bg-white py-6 border-t border-gray-200">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-col md:flex-row items-center justify-between text-sm text-neutral-gray">
              <p>© 2025 Solutions Healthcare LLC. All rights reserved.</p>
              <div className="flex items-center space-x-4 mt-4 md:mt-0">
                <a href="#privacy" className="hover:text-primary transition-colors cursor-pointer">
                  Privacy Policy
                </a>
                <span>|</span>
                <a href="#terms" className="hover:text-primary transition-colors cursor-pointer">
                  Terms of Service
                </a>
                <span>|</span>
                <a href="#accessibility" className="hover:text-primary transition-colors cursor-pointer">
                  Accessibility
                </a>
                <span>|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors cursor-pointer">
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;